import { viewTypes } from '../AssessmentsContext'
import { AssessmentTableTabs, SummaryTable } from '..';
import Profiles from 'pages/School/Profiles/WrapProfiles';
import Profiles2 from 'pages/School/Profiles/WrapProfiles2';
import { AbilityContext } from 'components/Permissions/Can';
import { useContext } from 'react';
import WrapReadingGroups from 'pages/School/Profiles/ReadingGroups/WrapReadingGroups';

const useViewTypesHeaderBtns = () => {

    const ability = useContext(AbilityContext)
    const isSuperuser = ability.can("manage", "super-user")

    const viewTypeBtns = [
        {
            type: viewTypes.profile,
            label: "חלוקה לדירוגים",
            icon: <i className="fa-regular fa-layer-group" />,
            tooltip: "חלוקה לפי דירוג שטף הקריאה",
            component: Profiles,
            overflow: true,
            i: "fa-regular fa-people"
        },
        {
            type: viewTypes.table,
            label: "טבלת דוחות",
            icon: <i className="fa-regular fa-list-ul" />,
            tooltip: "טבלה",
            component: AssessmentTableTabs,
            overflow: false,
            i: "fa-regular fa-list-ul"
        },
        {
            type: viewTypes.profile2,
            label: "חלוקה לתחומי בדיקה",
            icon: <i className="fa-regular fa-table-cells-large" />,
            tooltip: "חלוקה לפי תחומי בדיקה",
            component: Profiles2,
            overflow: true,
            i: "fa-sharp fa-thin fa-people-line"
        },
        // {
        //     type: viewTypes.chart,
        //     label: "התפלגות ביצועים",
        //     icon: <i className="fa-regular fa-chart-pie" />,
        //     tooltip: "גרפים של התפלגות ביצועים",
        //     component: DoughnutCharts,
        //     overflow: true,
        //     i: "fa-regular fa-chart-pie"
        // },
        {
            type: viewTypes.readingGroups,
            label: "קבוצות קריאה",
            icon: <i className="fa-regular fa-users" />,
            tooltip: "קבוצות קריאה",
            component: WrapReadingGroups,
            overflow: true,
            i: "fa-regular fa-users"
        },
        {
            type: viewTypes.generalSummary,
            label: "טבלת סיכום",
            icon: <i className="fa-regular fa-users" />,
            tooltip: "טבלת סיכום",
            component: SummaryTable,
            overflow: true,
            i: "fa-regular fa-users",
        },
    ]

    return viewTypeBtns
}

export default useViewTypesHeaderBtns
